import React, { Fragment, Suspense } from "react";
import Preloader from "../elements/Preloader";
const Breadcrumb = React.lazy(() => import("../components/Breadcrumb"));
const ContactOne = React.lazy(() => import("../components/ContactOne"));
const Branches1 = React.lazy(() => import("../components/Branches"));
const FooterBottomOne = React.lazy(() =>
  import("../components/FooterBottomOne")
);
const FooterOne = React.lazy(() => import("../components/FooterOne"));
const NavbarOne = React.lazy(() => import("../components/NavbarOne"));

const SearchPopup = React.lazy(() => import("../elements/SearchPopup"));
const Branches = () => {
  return (
    <>
      <Fragment>
        <Suspense fallback={<Preloader />}>
          {/* Search Popup */}
          <SearchPopup />

          {/* Navbar One */}
          <NavbarOne />

          {/* Breadcrumb */}
          <Breadcrumb title={"Branches"} />

          {/* Faq One */}
          <div className='faq-area pd-top-20 pd-bottom-120'>
            <Branches1 />
          </div>

           {/* Footer One */}

          <FooterOne />

          {/* Footer Bottom One */}

          <FooterBottomOne />
        </Suspense>{" "}
      </Fragment>
    </>
  );
};

export default Branches;
